module.exports = __webpack_public_path__ + "img/group_m1.6172faac.png";